import { useNavigate, useParams } from "react-router-dom";
import Fade from "../components/Fade";
import LogoFooter from "../components/LogoFooter";
import { useEffect, useState } from "react";
import { invoke } from "@tauri-apps/api/core";
import { listen } from "@tauri-apps/api/event"

export default function Informacao() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [atendimento, setAtendimento] = useState(null);

  const [imagens, setImagens] = useState([]);

  const [link, setLink] = useState(null);

  const invoke = window.__TAURI__.core.invoke;

  listen('link', (event) => {
    console.log(event.payload)
    setLink(event.payload)
  });

  // console.log(atendimento);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/tema/${id}`)
      .then((response) => response.json())
      .then((data) => {
        invoke('abre_janela', {url: data.link})
        setAtendimento(data);
      })
      .catch((error) => console.log(error));
  }, [id]);

  useEffect(() => {
    const interval = setInterval(() => {
      window.location.href = process.env.REACT_APP_ROOT_FOLDER || "/";
      invoke('fecha_janela', {label: "external"})
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const sistema = atendimento?.sistemas?.[0];

  useEffect(() => {
    if (!sistema?.id) return;

    fetch(
      `${process.env.REACT_APP_API_URL}/api/totem-imgs/?sistema_id=${sistema.id}`,
    )
      .then((res) => res.json())
      .then((data) => setImagens(data))
      .catch((err) => console.log(err));
  }, [sistema?.id]);

  if (!atendimento || !sistema) return null;

  return (
    <Fade>
      <div className="flex flex-col min-h-screen">
        <div
          className="min-h-[130px] flex items-center px-20"
          style={{
            backgroundColor: atendimento.cor || "#1E3A5F",
          }}
        >
          <div className="max-w-[1240px]">
            <h1 className="text-white text-5xl font-bold font-tommy">
              {atendimento.nome}
            </h1>
          </div>
        </div>

        <div className="flex-1 px-20 pt-8">
          <div className="flex items-start gap-10">
            <div className="flex-shrink-0 h-[600px]">
              <img
                src={
                  imagens?.[0] ? `data:image/*;base64,${imagens[0].imagem}` : ""
                }
                alt=""
                className="h-full w-auto object-contain"
              />
            </div>

            <div className="flex flex-col justify-between flex-1 h-[590px]">
              <p className="text-3xl text-deepBlue w-[90%]">{sistema.sobre}</p>

              <div className="flex items-center gap-6">
                <img
                  src={sistema.qrcode}
                  alt="QR Code"
                  className="w-40 h-40 object-contain"
                />

                <div className="text-deepBlue">
                  <p className="text-2xl">
                    escaneie o <strong>QR Code</strong>
                  </p>

                  <p className="text-2xl">para mais informações</p>
                </div>
              </div>

              <div className="flex items-end justify-between w-full">
                <button
                  onClick={() => navigate("/atendimento")}
                  className="
                    min-w-[200px]
                    py-4
                    border-2
                    border-deepBlue
                    text-deepBlue
                    px-12
                    rounded-2xl
                    text-3xl
                    font-semibold
                    transition
                    hover:bg-deepBlue
                    hover:text-white
                  "
                >
                  Voltar
                </button>

                <div className="pr-16">
                  <LogoFooter />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white w-full">
          <div className="max-w-[1280px] mx-auto flex justify-between items-center">
            <button className="min-w-[200px] py-4 border-2 border-deepBlue text-deepBlue px-12 rounded-2xl text-3xl font-semibold" onClick={function(){
                    if(link === atendimento.link){
                      navigate("/atendimento")
                      invoke('fecha_janela', {label: "external"})
                    } else {
                      invoke('voltar_pagina', {label: "external"})
                    }
                  }}>
              Voltar
            </button>

            <div className="p-6">
              <LogoFooter />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
